{
  "pt": {
    "employee": {
      "actions": {
        "accessProjects": "Gerir o acesso aos projectos",
        "cancel": "Anular",
        "changeProfilePicture": "Alterar a imagem do perfil",
        "change_role": "Alterar a função para",
        "download": "Download",
        "new": "Membro da equipa",
        "profilePictureFormat": "Deve ter pelo menos 300x300px",
        "save": "Guardar",
        "searchEmployee": "Membro da equipa de pesquisa",
        "sendinvitation": "Criar e enviar o convite",
        "submit": "Guardar",
        "undoChanges": "Anular"
      },
      "attributes": {
        "email_address": "Correio eletrónico",
        "email_notifications_interval": {
          "daily": "Uma vez por dia (por volta do meio-dia)",
          "hourly": "Cada hora",
          "twice_daily": "Duas vezes por dia (manhã/tarde)",
          "weekly": "Uma vez por semana (segunda-feira ao meio-dia)"
        },
        "first_name": "Nome próprio",
        "language": "Língua",
        "last_name": "Apelido",
        "phone_landline": "Número de telefone fixo",
        "phone_mobile": "Número de telemóvel",
        "profession": "Título do emprego",
        "role": "Direitos de acesso",
        "signature_html": "Assinatura de conversação",
        "status": "Estado",
        "title": "Título"
      },
      "integrations": {
        "hide_details": "Ocultar detalhes",
        "last_synced_at": "Última sincronização em: {time}",
        "show_details": "Mostrar detalhes"
      },
      "labels": {
        "all_projects": "Todos os projectos",
        "confirmPasswordReset": "Foi enviada uma mensagem de correio eletrónico com uma ligação para redefinir a sua palavra-passe. Contacte-nos se tiver algum problema.",
        "disabled": {
          "access": "Concederemos a todos os empregados acesso à plataforma a partir do momento em que a última fatura em atraso for paga.",
          "contact": "Contactar-nos",
          "overdue": "Verificámos que a sua última fatura está muito atrasada. Revogámos o acesso de todos os funcionários a esta plataforma. Os parceiros e clientes continuarão a poder aceder aos seus dados.",
          "title": "A sua conta foi desactivada!"
        },
        "display": "Mostrar",
        "filters": "Filtros",
        "generalNotifications": "Notificar-me sobre",
        "has_access_to": "Tem acesso a",
        "information": "Informações sobre o perfil",
        "informationNotificationsEmail": "Receber um resumo por correio eletrónico, incluindo apenas as notificações que ainda não viu na plataforma.",
        "informationNotificationsPlatform": "Receber todas as notificações na sua visão geral pessoal no canto superior direito do ecrã",
        "informationNotificationsTitle": "Decida que tipo de notificações pretende receber e como",
        "its_you!": "És tu!",
        "last_login": "Último login",
        "maintainerAccess": "Requer acesso por projeto.",
        "name": "Nome",
        "onPlatform": "Na plataforma",
        "ownerAccess": "Tem acesso a todos os projectos e conteúdos na plataforma {client_name}.",
        "password": "Palavra-passe",
        "permissions": "Direitos de acesso para",
        "permissionsOwnerOnly": "Como Mantenedor do Projeto, não pode realizar esta ação. Por favor, peça a um membro da equipa {client_name} com o papel de Proprietário para fazer isto por si.",
        "projectMaintains": "{first_name} tem acesso aos seguintes projectos:",
        "projectMaintainsAdd": "Para conceder acesso, seleccione um projeto e adicione {first_name} como um Mantenedor de projeto na funcionalidade Informações.",
        "projectMaintainsNone": "não tem acesso a nenhum projeto.",
        "projectNotifications": "Para o projeto",
        "show_signature": "Mostrar assinatura",
        "signature_active": "Assinatura ativa",
        "signature_info": "Esta assinatura será acrescentada às respostas enviadas aos clientes e parceiros.",
        "sorting": "Classificação",
        "viaEmail": "Por correio eletrónico"
      },
      "modals": {
        "maintainers_access": {
          "accessible": "Acessível",
          "description": "As alterações são salvas automaticamente",
          "not_accessible": "Não acessível",
          "title": "Atualizar acessibilidade do projeto para {first_name} {last_name}"
        }
      },
      "roles": {
        "maintainer": "Mantenedor",
        "owner": "Proprietário"
      },
      "toasts": {
        "create": "Foi criado um membro da equipa",
        "update": "O membro da equipa foi atualizado"
      },
      "validation": {
        "emailTaken": "O endereço de correio eletrónico já foi utilizado",
        "mustBeEmailAddress": "É necessário um endereço de correio eletrónico válido",
        "needFirstName": "Nome próprio obrigatório",
        "needLastName": "Apelido obrigatório",
        "requireEmailAddress": "Correio eletrónico necessário",
        "role": "Selecionar direitos de acesso"
      }
    }
  }
}